import type { FlexFactory } from "@mantine/core";
import { Flex } from "@mantine/core";

function MantineNullCell({ flexProps }: { flexProps?: FlexFactory["props"] }) {
  return (
    <Flex align="center" {...flexProps}>
      –
    </Flex>
  );
}

function renderNullableCell({
  renderedCellValue,
  flexProps
}: {
  renderedCellValue: React.ReactNode;
  flexProps?: FlexFactory["props"];
}): React.ReactNode {
  return renderedCellValue ?? <MantineNullCell flexProps={flexProps} />;
}

export { MantineNullCell, renderNullableCell };
